var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',[_c('h1',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.title))])]),(_vm.subtitle)?_c('v-card-subtitle',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }